import { render, staticRenderFns } from "./GroupInfoPage.vue?vue&type=template&id=4b41f1ab&scoped=true&"
import script from "./GroupInfoPage.vue?vue&type=script&lang=ts&"
export * from "./GroupInfoPage.vue?vue&type=script&lang=ts&"
import style0 from "./GroupInfoPage.vue?vue&type=style&index=0&id=4b41f1ab&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b41f1ab",
  null
  
)

export default component.exports